import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Icon, Typography } from '@telus-uds/components-web';
import Calendar from '@telus-uds/palette-allium/build/web/icons/Calendar';
import DatePicker from 'react-datepicker';
import { DateWrapper } from '../../filters/css';
import 'react-datepicker/dist/react-datepicker.css';
import { getFormattedDate, getDisabledDates } from '../../utils/utils';
import Note from '../../note';
import { BoldFieldLabel } from './css';

const FieldDate = ({ data }) => {
  const {
    ref,
    value,
    placeholder,
    label,
    onChange,
    name,
    minDate,
    required,
    note,
    isShowNoteBackground,
    disableHolidays = false,
    isItalicNote
  } = data;
  return (
    // FB2-9: match the standard field wrapper's 8.5px top/bottom spacing so the
    // two adjacent date fields are separated like every other installation field.
    <div style={{ marginTop: '8.5px', marginBottom: '8.5px' }}>
      <div>
        <BoldFieldLabel>
          <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
            {label}
            {required && `*`}
          </Typography>
        </BoldFieldLabel>
      </div>
      {note && note.content && (
        <Note
          type="richText"
          isItalicNote={isItalicNote}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
      {/* FB2-9: drop the DateWrapper's responsive top/bottom margin (8px at ≤992px)
          so the label→input gap matches the other installation fields; the field's
          own separation is handled by the root wrapper's 8.5px margin above. */}
      <DateWrapper
        width="100%"
        position="relative"
        style={{ marginTop: 0, marginBottom: 0 }}
      >
        <DatePicker
          portalId="datepicker-portal"
          dateFormat="yyyy/MM/dd"
          popperPlacement="top-start"
          placeholderText={placeholder}
          selected={value && moment(value).toDate()}
          filterDate={disableHolidays && getDisabledDates}
          onChange={dateValue => {
            onChange({
              target: {
                name,
                value: getFormattedDate(
                  dateValue || (value && moment(value).toDate())
                )
              }
            });
          }}
          minDate={(minDate && moment(minDate).toDate()) || 0}
        />
        <div
          style={{ position: 'absolute', top: '0.7rem', right: '0.7rem' }}
          ref={ref}
        >
          <Icon icon={Calendar} variant={{ size: 'small' }} />
        </div>
      </DateWrapper>
    </div>
  );
};

FieldDate.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.string.isRequired
  }).isRequired
};

export default FieldDate;
